import React from 'react';

export default function NotificactionScreen({ children }) {
  return <div className='h-100-vh d-flex flex-column justify-content-center'>{children}</div>;
}
